import { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Tooltip } from 'bootstrap';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getStudentImage } from '../../../common/styles/Images';
import InitialsAvatar from '../../../library/SimpleControls/InitialsAvatar';
import { allowPerformAction, canExportToExcel, canSendDirectoryMessage, displayActionNotAllowedAlert, exportToExcel, formatFullName, getActionElementClass, getDirectorySendDisabledTooltip, isEmpty } from '../../../library/Core/SmartFunctions';
import SessionContext from '../../../library/Core/SessionContext';
import CardBottom from '../alumni-directory/CardBottom';
import GetStartedPromptModal from '../recruiter-directory/GetStartedPromptModal';

const DomainExpertCardGridControl = () => {
    const { state } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);
    const students: any[] = (state as any).data?.students || [];

    const [displayed, setDisplayed] = useState<any[]>(students.slice(0, 20));
    const [hasMore, setHasMore]     = useState(students.length > 20);

    useEffect(() => {
        setDisplayed(students.slice(0, 20));
        setHasMore(students.length > 20);
    }, [students]);

    useEffect(() => {
        // Initialize tooltips when the component mounts
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('.btn-white-tooltip'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl, {
                customClass: 'tooltip-white'
            });
        });
    
        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, [displayed]);

    const fetchMore = () => {
        if (displayed.length >= students.length) { setHasMore(false); return; }
        setDisplayed((prev) => [...prev, ...students.slice(prev.length, prev.length + 20)]);
    };

    const profileLink = (uuid: string) => `/alumni/${uuid}/profile`;

    const isEmailVerified: number = localStorage.getItem('isEmailVerified')
        ? Number(localStorage.getItem('isEmailVerified'))
        : 1;

    const stageLabel = (stage: string | null) => {
        if (!stage) return null;
        const labels: Record<string, string> = {
            identified: 'Identified', validated: 'Validated', warmed: 'Warmed',
            engaged: 'Engaged', qualified: 'Qualified', contribution: 'Contributing',
            dormant: 'Dormant', denied: 'Denied',
        };
        return labels[stage] || stage;
    };

    const stageBadgeClass = (stage: string | null) => {
        if (!stage) return '';
        const map: Record<string, string> = {
            qualified: 'bg-success text-white', contribution: 'bg-success text-white',
            engaged: 'bg-primary text-white', validated: 'bg-info text-dark',
            warmed: 'bg-warning text-dark', identified: 'bg-secondary text-white',
            dormant: 'bg-light text-muted border', denied: 'bg-danger text-white',
        };
        return map[stage] || 'bg-light text-dark border';
    };

    const noRecordsFound = () => (
        <div className="row g-2 g-md-4 alumni-showcase" id="FilterData">
            <div className="no_listed_items_blk">
                <div className="mt-0">
                    <div className="max-470 mx-auto">
                        <img
                            className="mt-2 mb-4 float_horizontal_animate"
                            src={`${process.env.REACT_APP_IMAGE_BASEPATH}/alumni_directory_nodata.svg`}
                            alt="No data"
                        />
                        <p className="font-18 font-400 mb-4 text-center">
                            No domain experts found matching your search criteria.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );


    const showExportButton = canExportToExcel(sessionState);

    const handleExportToExcel = () => exportToExcel(students, 'domain-expert-directory', state);

return (
        <section className="alumni_directory_details bg-white container-fluid">
                        <div className="max-1140 pt-4 pb-5 mx-auto">
               <div className="d-flex justify-content-between align-items-center mb-3">
                    {showExportButton && (
                        <button
                            className="btn btn-success d-flex align-items-center"
                            disabled={
                                state?.flags?.isDataLoading ||
                                !(state?.data?.students?.length > 0)
                            }
                            onClick={handleExportToExcel}>
                            Export to Excel
                        </button>
                    )}

                    <div className="alumni_count" id="UsersCounts">
                        {state?.data?.students?.length ?? 0} Alumni Found
                    </div>
                </div>

        <InfiniteScroll dataLength={displayed.length} next={fetchMore} hasMore={hasMore} loader="">
                <div className="overflow-hidden">
                <div className="row g-2 g-md-4 alumni-showcase">
                    {displayed.map((student: any) => {
                        const isValueZone =
                            ["qualified", "contribution"].includes(student.atStage) ||
                            ["qualified", "contribution"].includes(student.cgStage);

                        return (
                            <div key={student.uuid} className="col-lg-4 col-md-6 col-sm-6 Dusers">
                                <div className="alumni-bucket">
                                    <div className="alumni_class_link">

                                        {/* Profile image + name */}
                                        <div className="alumni_name_detail">
                                            <div className="alumni_img overflow-visible">
                                                <a
                                                    className="alumni_img_link d-flex"
                                                    target="_blank"
                                                    href={profileLink(student.uuid)}
                                                    rel="noreferrer"
                                                >
                                                    <i className="position-relative">
                                                        {student.profilePictureFilePath ? (
                                                            <img
                                                                className="img-fluid"
                                                                src={getStudentImage(student)}
                                                                alt={student.name}
                                                            />
                                                        ) : (
                                                            <InitialsAvatar firstName={student.firstName} lastName={student.lastName} name={student.name} />
                                                        )}
                                                    </i>
                                                </a>
                                            </div>

                                            <div className="alumni_name_brife">
                                                <h3>
                                                    <a
                                                        className="btn-white-tooltip"
                                                        href={profileLink(student.uuid)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-html="true"
                                                        title={student.name}
                                                        target="_blank"
                                                    >
                                                        {student.name}
                                                    </a>
                                                </h3>

                                                <span className="alumni_campus">
                                                    {student.programName}, {student.passOutYear}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Send Button */}
                                        <div className="send_link d-flex align-items-center">
                                            {isEmailVerified == 1 && canSendDirectoryMessage(student) ?
                                                <GetStartedPromptModal
                                                    loginId={sessionState?.id}
                                                    userTypeCode={sessionState?.userTypeCode}
                                                    name={`${sessionState?.firstName} ${sessionState?.lastName}`}
                                                    programId={sessionState?.institutes?.[0]?.programId}
                                                    student={student}
                                                    className={`btn-send ${getActionElementClass()}`} imgWidth={506}/>
                                                :
                                                <a href="javascript:;" className="btn-send btn-white-tooltip" style={{background:'grey'}} data-bs-toggle="tooltip" data-bs-html="true" data-bs-original-title={getDirectorySendDisabledTooltip(isEmailVerified, student)}><i className="icon-alumni-send"></i><span>Send</span></a>
                                            }
                                
                                            {student.badges === 1 && (
                                                <a
                                                    href="javascript:void(0)"
                                                    className="btn-monitor ms-2 btn-white-tooltip"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-html="true"
                                                    data-bs-original-title="Mentor Badge"
                                                >
                                                    <i className="icon-multiple-users"></i>
                                                </a>
                                            )}
                                        </div>

                                        {/* Value Zone + Capture Commitment — same line. Only rendered when there's
                                            something to show, so an empty row doesn't leave a blank gap. */}
                                        {(isValueZone || student.domainExpertiseArea) && (
                                        <div className="verify_massrecruiter align-items-center justify-content-between flex-wrap gap-2">
                                            <ul className="gap-1 mt-1">
                                                {isValueZone && (
                                                    <li>
                                                        <i className="bi bi-star-fill"></i><span>
                                                            In Value Zone
                                                        </span>
                                                    </li>
                                                )}

     {student.domainExpertiseArea && (() => {
    const areas: string[] = student.domainExpertiseArea
        .split(',')
        .map((area: string) => area.trim())
        .filter(Boolean);

    const MAX_LENGTH = 35;

    let displayText = '';
    let visibleCount = 0;

    for (const area of areas) {
        const nextText = displayText ? `${displayText}, ${area}` : area;

        if (nextText.length <= MAX_LENGTH) {
            displayText = nextText;
            visibleCount++;
        } else {
            break;
        }
    }

    // Show total count instead of hidden count
    if (visibleCount < areas.length) {
        displayText += `... (${areas.length})`;
    }

    const tooltipHtml = areas.map((area) => `• ${area}`).join('<br/>');

    return (
        <li style={{ minWidth: 0, maxWidth: 260 }}>
            <div
                className="d-flex align-items-center gap-1 text-dark"
                style={{ minWidth: 0 }}
            >
                <i className="bi bi-person-gear font-20 me-0 flex-shrink-0"></i>

                <span
                    className="font-400 text-truncate d-inline-block btn-white-tooltip"
                    style={{ maxWidth: 260, minWidth: 0 }}
                    data-bs-toggle="tooltip"
                    data-bs-html="true"
                    title={tooltipHtml}
                >
                    {displayText}
                </span>
            </div>
        </li>
    );
})()}

                                                {/* {student.atStage && (
                                                    <li>
                                                        <span className={`badge font-11 ${stageBadgeClass(student.atStage)}`}>
                                                            AT: {stageLabel(student.atStage)}
                                                        </span>
                                                    </li>
                                                )}

                                                {student.cgStage && (
                                                    <li>
                                                        <span className={`badge font-11 ${stageBadgeClass(student.cgStage)}`}>
                                                            CG: {stageLabel(student.cgStage)}
                                                        </span>
                                                    </li>
                                                )} */}
                                            </ul>

                                            {/* {!student.hasCommitmentResponse && (
                                                <a
                                                    href={`/commitment/capture/${student.instituteId}/${student.uuid}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className={`btn btn-warning rounded-pill text-warning-emphasis py-1 font-12 text-decoration-none ${getActionElementClass()}`}
                                                    style={{  whiteSpace: 'nowrap' }}
                                                >
                                                    Capture Commitment
                                                </a>
                                            )} */}
                                        </div>
                                        )}

                                        
                                    </div>

                                    <CardBottom alumni={student} state={state} />
                                </div>
                            </div>
                        );
                    })}
            </div>
            </div>
        </InfiniteScroll>

        {!(state as any).flags?.isDataLoading && students.length === 0 && noRecordsFound()}
        </div>
        </section>
    );
};

export default DomainExpertCardGridControl;
